import React from "react";
import style from "./Modalities.module.scss";
import { signedLockedAccess } from "../../../../utils";
import { PERMISSIONS } from "../../../../constants/permissions";
import { EditActionButton } from "../../../secondary/EditActionButton/EditActionButton";

export const MultiSelectSectionViewMode = ({
  label,
  sectionData,
  listResp,
  assessmentDetails,
  onEdit,
  hasPermission,
}) => (
  <div className={style.viewMode_container}>
    <div className="d-flex justify-content-between">
      <div className={`${style.lab_container} d-flex col-11 p-0`}>
        <label className="col-5 p-0">{label}</label>
        <div className="col-6 p-0">
          {sectionData?.length > 0 &&
            sectionData.map((e) => {
              const match = listResp?.find((l) => e === l.key);
              return (
                <div className="font-weight-bold" key={e}>
                  {match?.value ?? ""}
                </div>
              );
            })}
        </div>
      </div>

      <div>
        {signedLockedAccess(assessmentDetails?.assessmentStage) && (
          <EditActionButton
            onClick={onEdit}
            disabled={!hasPermission(PERMISSIONS.TREATMENT_EDIT)}
          />
        )}
      </div>
    </div>
  </div>
);